var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C16.6944 1 20.5 4.80557 20.5 9.5C20.5 12.4856 19.1222 15.5046 16.8188 18.4506C16.0013 19.4961 15.1122 20.471 14.2014 21.3589C14.1263 21.4321 14.0525 21.5033 13.9801 21.5726L13.5621 21.9646L13.1806 22.3085L12.8398 22.6027L12.6317 22.7752C12.2665 23.0728 11.7432 23.0752 11.3753 22.7809L11.1577 22.6007L10.8185 22.3077L10.4377 21.9645L10.0199 21.5726L9.79864 21.3589C8.8878 20.471 7.99872 19.4961 7.18121 18.4506C4.8778 15.5046 3.5 12.4856 3.5 9.5C3.5 4.80557 7.30557 1 12 1ZM12 3C8.41013 3 5.5 5.91013 5.5 9.5C5.5 11.9562 6.70279 14.5917 8.75676 17.2187C9.5151 18.1885 10.3446 19.0981 11.1947 19.9268L11.5975 20.3121C11.7301 20.4366 11.863 20.5612 12 20.681L12.4025 20.3121L12.8053 19.9268C13.6554 19.0981 14.4849 18.1885 15.2432 17.2187C17.2972 14.5917 18.5 11.9562 18.5 9.5C18.5 5.91013 15.5899 3 12 3ZM12 5.5C14.2091 5.5 16 7.29086 16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5ZM12 7.5C10.8954 7.5 10 8.39543 10 9.5C10 10.6046 10.8954 11.5 12 11.5C13.1046 11.5 14 10.6046 14 9.5C14 8.39543 13.1046 7.5 12 7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.97e94c529bf7ad91e0e5bf5878e714c7.svg";
export { ForwardRef as ReactComponent };